export const DefaultSteemEngineRpcs = [
    'https://api.steem-engine.com/rpc',
];
export const DefaultAccountHistoryApis = ['https://history.steem-engine.com'];
